var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCredentialsbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 406,
    viewBox: "0 0 1440 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1439.69 7.11198L1438.23 3.94082C1439.52 3.34724 1441.02 3.3503 1442.31 3.96712M1439.69 7.11198L1442.31 3.96712M1439.69 7.11198L1438.23 3.94083L1394.4 24.1091C1393.09 24.7094 1392.1 25.8764 1391.75 27.3159L1380.63 73.2261M1439.69 7.11198L1380.63 73.2261M1442.31 3.96712L1485.86 24.7352C1487.16 25.3519 1488.13 26.5282 1488.45 27.9633L1498.91 74.0289L1495.5 74.804M1442.31 3.96712L1495.5 74.804M1495.5 74.804L1498.91 74.0289C1499.24 75.4814 1498.86 76.9822 1497.93 78.1029L1467.44 114.77C1466.51 115.885 1465.14 116.51 1463.71 116.5L1415.22 116.171C1413.8 116.161 1412.44 115.529 1411.53 114.399M1495.5 74.804L1411.53 114.399M1411.53 114.399L1381.55 77.3055C1380.63 76.1642 1380.29 74.6588 1380.63 73.2261M1411.53 114.399L1380.63 73.2261",
    stroke: "url(#paint0_linear_210_25467)",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1420.32 97.4287L1422.26 95.8587L1420.32 97.4287C1420.96 98.228 1421.93 98.6759 1422.93 98.6827L1456.19 98.9086C1457.2 98.9155 1458.17 98.4731 1458.83 97.6847L1479.74 72.4957C1480.4 71.7033 1480.67 70.6428 1480.44 69.6168L1478 70.1697L1480.44 69.6168L1473.26 37.9717C1473.03 36.9579 1472.35 36.1256 1471.43 35.6889L1441.56 21.4221L1440.48 23.6711L1441.56 21.4221C1440.64 20.9853 1439.58 20.9831 1438.67 21.4035L1439.72 23.674L1438.67 21.4035L1408.6 35.2582L1409.65 37.5287L1408.6 35.2582C1407.68 35.6832 1406.98 36.5089 1406.73 37.5257L1399.11 69.0641C1398.86 70.076 1399.1 71.1398 1399.76 71.9468L1420.32 97.4287Z",
    stroke: "url(#paint1_linear_210_25467)",
    strokeWidth: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.0984 338.691L39.5923 335.558C40.7842 336.127 41.6798 337.212 41.9814 338.54M38.0984 338.691L41.9814 338.54M38.0984 338.691L39.5923 335.558L8.74203 320.848L7.24529 323.986M38.0984 338.691L7.24529 323.986M41.9814 338.54L49.3917 371.17L45.9786 371.945M41.9814 338.54L45.9786 371.945M45.9786 371.945L49.3917 371.17C49.6969 372.514 49.3464 373.9 48.4867 374.934L45.7956 372.696L48.4867 374.934L26.888 400.907L24.1969 398.669L26.8879 400.907C26.0332 401.935 24.7676 402.509 23.4558 402.5L-10.8953 402.267C-12.1946 402.258 -13.452 401.677 -14.2955 400.633L-35.5292 374.358M45.9786 371.945L-35.5292 374.358M7.24529 323.986L8.74202 320.848C7.55023 320.279 6.17271 320.277 4.9857 320.823L-26.0615 335.109C-27.2622 335.661 -28.1792 336.737 -28.5015 338.067L-36.3773 370.587C-36.6981 371.912 -36.3815 373.304 -35.5292 374.358M7.24529 323.986L-35.5292 374.358",
    stroke: "url(#paint2_linear_210_25467)",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.5817 368.662L36.0198 368.109C36.2355 369.061 35.9879 370.043 35.3795 370.776L20.5638 388.618C19.9588 389.346 19.0619 389.754 18.1314 389.748L-5.43174 389.588C-6.3534 389.582 -7.24449 389.168 -7.84168 388.428L-6.02658 386.964L-7.84168 388.428L-22.4069 370.379C-23.0101 369.631 -23.2338 368.645 -23.007 367.708L-20.5777 368.295L-23.007 367.708L-17.6046 345.368L-15.2088 345.948L-17.6046 345.368C-17.3767 344.426 -16.7281 343.663 -15.877 343.271L5.41984 333.457M33.5817 368.662L5.41984 333.457M33.5817 368.662L36.0198 368.109L30.9366 345.694C30.7234 344.754 30.0899 343.984 29.2449 343.58L28.1763 345.818M33.5817 368.662L28.1763 345.818M5.41984 333.457C6.26133 333.07 7.2382 333.071 8.08318 333.475L29.2449 343.58L28.1763 345.818M5.41984 333.457L28.1763 345.818",
    stroke: "url(#paint3_linear_210_25467)",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_210_25467",
    x1: 1375.83,
    y1: -5.89226,
    x2: 1495.16,
    y2: 139.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F6CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7360C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_210_25467",
    x1: 1395.91,
    y1: 14.7349,
    x2: 1477.91,
    y2: 114.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F6CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7360C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_210_25467",
    x1: -38.7881,
    y1: 314.785,
    x2: 45.7376,
    y2: 417.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F6CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7360C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_210_25467",
    x1: -24.5641,
    y1: 329.396,
    x2: 33.5178,
    y2: 399.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F6CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7360C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialsbg);
export default __webpack_public_path__ + "static/media/credentialsbg.aeecb2136584129cfd91f75bcb072e7c.svg";
export { ForwardRef as ReactComponent };